import React, { Fragment, useContext } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../Layout/Layout';
import PrivilegeContext from '../_helper/PrivilegeContext';

const LayoutRoutes = () => {
  const { privileges } = useContext(PrivilegeContext);

  // Helper function for access control (placed outside the JSX)
  const hasAccess = (menuKey = null, subPermissionKey = null, actionKey = null) => {
    if (privileges) {
      if (menuKey) {
        const permission = privileges.permissions.find((perm) => perm.menu_key === menuKey);

        if (!permission) return false;

        if (subPermissionKey) {
          const subPermission = permission.sub_permissions.find((sub) => sub.key === subPermissionKey);
          if (!subPermission) return false;

          if (actionKey) {
            return (
              subPermission.actions.some((action) => action.key === actionKey && action.allowed) ||
              subPermission.full_access
            );
          }

          return subPermission.full_access;
        }

        if (actionKey) {
          return permission.actions.some((action) => action.key === actionKey && action.allowed);
        }

        return permission.full_access;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  return (
    <Routes>
      {routes.map(({ path, Component, menu_key, sub_permission_key, action_key }, i) => {
        const isAccessible = hasAccess(menu_key, sub_permission_key, action_key);

        return (
          <Fragment key={i}>
            <Route element={<AppLayout />} key={i}>
              <Route
                path={path}
                element={
                  isAccessible ? (
                    Component
                  ) : (
                    <Navigate to={`${process.env.PUBLIC_URL}/unauthorized`} />
                  )
                }
              />
            </Route>
          </Fragment>
        );
      })}
      {/* Wildcard route for handling 404 Not Found */}
      <Route path="*" element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard`} />} />
    </Routes>
  );
  // return (
  //   <>
  //     <Routes>
  //       {routes.map(({ path, Component }, i) => (
  //         <Fragment key={i}>
  //           <Route element={<AppLayout />} key={i}>
  //             <Route path={path} element={Component} />
  //           </Route>
  //         </Fragment>
  //       ))}
  //     </Routes>
  //   </>
  // );
};

export default LayoutRoutes;